import { render } from "./WindowContent.vue?vue&type=template&id=cfa3b9b0&scoped=true&ts=true"
import script from "./WindowContent.vue?vue&type=script&lang=ts"
export * from "./WindowContent.vue?vue&type=script&lang=ts"

import "./WindowContent.vue?vue&type=style&index=0&id=cfa3b9b0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfa3b9b0"]])

export default __exports__